import { Checkbox, Tag } from 'antd';
import { HolderOutlined } from '@ant-design/icons';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { FieldOption } from '../../api/types';
import styles from './styles.module.css';

interface FieldItemProps {
  field: FieldOption;
  onToggle: (id: string) => void;
}

export function FieldItem({ field, onToggle }: FieldItemProps) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: field.id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
  };

  return (
    <li
      ref={setNodeRef}
      style={style}
      className={`${styles.item} ${isDragging ? styles.itemDragging : ''}`}
    >
      <span className={styles.handle} {...attributes} {...listeners} aria-label="拖拽排序">
        <HolderOutlined />
      </span>
      <Checkbox checked={field.checked} onChange={() => onToggle(field.id)} />
      <span className={styles.name} title={field.name}>
        {field.name}
      </span>
      <Tag color="blue" style={{ marginInlineEnd: 0 }}>
        t{field.type}
      </Tag>
    </li>
  );
}
